'use memo'

import React from 'react'
import FullScreenOverlay from 'src/components/FullScreenOverlay'
import { EditPlayerProvider } from './EditPlayerContext'
import EditPlayerModalContent from './EditPlayerModalContent'

interface Props {
  isOpen: boolean
  onClose: () => void
  /**
   * When provided, the player is fetched (GET /players/:id via React Query) and
   * the form is pre-populated. When absent, the form opens empty and no fetch
   * happens. Any feature can reuse this modal as an entry point by passing a
   * playerId.
   */
  playerId?: string
  onSuccess?: () => void
}

const EditPlayerModal: React.FC<Props> = ({
  isOpen,
  onClose,
  playerId,
  onSuccess,
}) => {
  return (
    <FullScreenOverlay isOpen={isOpen}>
      <EditPlayerProvider
        onClose={onClose}
        onSuccess={onSuccess}
        playerId={playerId}
      >
        <EditPlayerModalContent />
      </EditPlayerProvider>
    </FullScreenOverlay>
  )
}

export default EditPlayerModal
